
export default {
	props: {
		text: String
	}
}
